export default "__VITE_ASSET__FosrRqsV__"